import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { PROCESS } from "../data/site";
import { Reveal } from "./Reveal";

export default function Process() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start center", "end center"] });
  const lineH = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="process" className="py-24 sm:py-32 bg-[#1B1B1B]" data-testid="process-section">
      <div className="container-lux">
        <Reveal className="max-w-3xl mb-16">
          <p className="overline mb-3">Our Process</p>
          <h2 className="font-head text-4xl sm:text-5xl uppercase tracking-tight">
            Four steps to a <span className="text-gold-metallic">perfect roof.</span>
          </h2>
        </Reveal>

        <div ref={ref} className="relative pl-10 sm:pl-0">
          {/* vertical line */}
          <div className="absolute left-[15px] sm:left-1/2 top-0 bottom-0 w-[2px] bg-white/10 -translate-x-1/2">
            <motion.div style={{ height: lineH }} className="w-full bg-gradient-to-b from-[#AA8922] to-[#E5C869]" />
          </div>

          <div className="space-y-14">
            {PROCESS.map((p, i) => (
              <Reveal key={p.no} delay={i * 0.05}
                className={`relative sm:w-1/2 ${i % 2 ? "sm:ml-auto sm:pl-14" : "sm:pr-14 sm:text-right"}`}>
                <span className={`absolute top-1 w-8 h-8 rounded-full bg-[#0D0D0D] border-2 border-[#D4AF37] flex items-center justify-center text-[10px] text-[#D4AF37] font-head
                  left-[-40px] sm:left-auto ${i % 2 ? "sm:-left-[16px]" : "sm:-right-[16px] sm:left-auto"}`}>
                  ●
                </span>
                <span className="font-head text-6xl text-white/10">{p.no}</span>
                <h3 className="font-head text-2xl uppercase tracking-tight mt-1 mb-2">{p.title}</h3>
                <p className="text-sm text-[#C8C8C8] leading-relaxed">{p.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
